/*
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2022-11-06 20:17:07
 * @LastEditTime: 2022-11-09 17:12:22
 * @Description: 
 */
import { defineStore } from 'pinia'
import login from '@/api/login'
import authority from '@/api/authority';
import { message } from 'ant-design-vue';


export const useLoginStore = defineStore('login', {
    state: () => {
        return {
            userName: null,
            passWord: null,
            errMessage: null,
            userInfo: {},
        }
    },
    getters: {},
    actions: {
        //登录
        login(params, router) {
            login.login(res => {
                if (res.code == 200) {
                    //登录成功后存储token
                    authority.setToken(res.data.token)
                    this.getInfoDetail(router)
                } else {
                    message.error(res.message)
                }
            }, params)
        },
        //查询用户信息
        getInfoDetail(router) {
            login.getInfoDetail(res => {
                if (res.code == 200) {
                    //存储用户信息
                    this.userInfo = res.data
                    sessionStorage.setItem('userInfo', JSON.stringify(res.data))

                    let name = location.hostname
                    if (name == 'message.cnri-tuv.com' || name == 'www.cnri-tuv.zeepson.com') {
                        localStorage.setItem('locale', 'zh-CN')
                    } else {
                        localStorage.setItem('locale', 'en-US')
                    }

                    router.push('/')
                        // setTimeout(() => {
                        //     location.reload(); //强制刷新,否则权限不能生效
                        // }, 300);
                } else {
                    message.error(res.message)
                }
            }, )
        },
    },
})